export enum AnalyticsReportType {
  PRODUCT = "product",
  VARIANT = "variant",
}

export enum AnalyticsFilterType {
  ORDER_CREATED_DATE = "orderCreatedDate",
  PRODUCT_NUM_SOLD = "productNumSold",
  VARIANT_NUM_SOLD = "variantNumSold",
  RETURN_TYPE = "returnType",
  SALES_CHANNEL = "salesChannel",
  RETURN_STATUS = "returnStatus",
  COMPENSATION_METHOD = "compensationMethod",
  VENDOR_NAME = "vendorName",
  PRODUCT_NAME = "productName",
  TAGS = "tags",
}

export const PRODUCT_ANALYTICS_FILTER_TYPES = [
  AnalyticsFilterType.ORDER_CREATED_DATE,
  AnalyticsFilterType.PRODUCT_NUM_SOLD,
  AnalyticsFilterType.RETURN_TYPE,
  AnalyticsFilterType.SALES_CHANNEL,
  AnalyticsFilterType.VENDOR_NAME,
  AnalyticsFilterType.PRODUCT_NAME,
  AnalyticsFilterType.TAGS,
] as const;

export function isValidProductAnalyticsFilterType(
  type: AnalyticsFilterType,
): type is (typeof PRODUCT_ANALYTICS_FILTER_TYPES)[number] {
  return (PRODUCT_ANALYTICS_FILTER_TYPES as readonly string[]).includes(type);
}

export const VARIANT_ANALYTICS_FILTER_TYPES = [
  AnalyticsFilterType.ORDER_CREATED_DATE,
  AnalyticsFilterType.VARIANT_NUM_SOLD,
  AnalyticsFilterType.RETURN_TYPE,
  AnalyticsFilterType.SALES_CHANNEL,
] as const;

export function isValidVariantAnalyticsFilterType(
  type: AnalyticsFilterType,
): type is (typeof VARIANT_ANALYTICS_FILTER_TYPES)[number] {
  return (VARIANT_ANALYTICS_FILTER_TYPES as readonly string[]).includes(type);
}

export function getValidFilterTypes(
  dataType: AnalyticsReportType,
): AnalyticsFilterType[] {
  switch (dataType) {
    case AnalyticsReportType.PRODUCT:
      return [...PRODUCT_ANALYTICS_FILTER_TYPES];
    case AnalyticsReportType.VARIANT:
      return [...VARIANT_ANALYTICS_FILTER_TYPES];
    default:
      return [];
  }
}
